
import moment from 'moment'

export default (dateString) => {
    var REFERENCE = moment(new Date());
    var A_WEEK_OLD = REFERENCE.clone().subtract(7, 'days').startOf('day');

    function isWithinAWeek(momentDate) {
        return momentDate.isAfter(A_WEEK_OLD)
    }
    const date = new Date(dateString)
    if (date) {
        if(isWithinAWeek(moment(date))){
           return moment(date).format('dddd [at] hh:mm A')
        }
        else {
           return moment(date).format('MM/DD/YY [at] hh:mm A');
        }
    }
    return dateString
  }